import { render, staticRenderFns } from "./CCSizeDownIcon.vue?vue&type=template&id=d23d8864&"
import script from "./CCSizeDownIcon.vue?vue&type=script&lang=js&"
export * from "./CCSizeDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports